<template>
  <div class="mt-1">
    <b-card>
      <b-overlay :show="loading" rounded="sm" no-fade>
        <b-row class="mb-1">
          <b-col
            cols="12"
            md="7"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-button
              variant="outline-primary"
              class="btn-icon"
              :to="{ name: 'events' }"
              ><i class="fa-solid fa-arrow-left"></i
              ><span class="ml-25">Back</span></b-button
            >
            <h3 class="ml-1">Duplicate Event</h3>
          </b-col>
        </b-row>

        <b-form v-if="loaded" @submit.prevent="onSubmit">
          <app-collapse accordion :type="'border'" class="mb-1">
            <!-- Event Details -->
            <app-collapse-item title="Event Details" :isVisible="true">
              <label>Course *</label>
              <v-select
                class="flex-grow-1 mb-1"
                :options="options.courses"
                label="title"
                :reduce="(c) => c.id"
                v-model="form.course_id"
                required
              />

              <b-row>
                <b-col md="4"
                  ><b-form-group label="Year *"
                    ><b-form-input
                      type="number"
                      v-model.number="form.year"
                      min="2000"
                      required/></b-form-group
                ></b-col>
                <b-col md="4"
                  ><b-form-group label="Time zone *"
                    ><b-form-input
                      v-model="form.time_zone"
                      required/></b-form-group
                ></b-col>
                <b-col md="4"
                  ><b-form-group label="Status"
                    ><v-select
                      :options="options.enums.event_statuses"
                      v-model="form.status"
                      :reduce="(v) => v"/></b-form-group
                ></b-col>
              </b-row>

              <div
                v-for="(s, idx) in sessions"
                :key="s.id ? s.id : idx"
                class="border rounded p-1 mb-1"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="mb-0">{{ getPartTitle(idx) }}</h6>
                  <b-button
                    v-if="sessions.length > 1"
                    size="sm"
                    variant="outline-danger"
                    @click="removeSession(idx)"
                    >Remove</b-button
                  >
                </div>
                <b-row class="mt-50">
                  <b-col md="4">
                    <label>Start</label>
                    <b-form-input type="date" v-model="s.start_date" />
                    <b-form-input
                      class="mt-25"
                      type="text"
                      v-model="s.start_time"
                      placeholder="HH:mm"
                      @blur="onTimeBlur(s, 'start_time')"
                    />
                  </b-col>
                  <b-col md="4">
                    <label>End</label>
                    <b-form-input type="date" v-model="s.end_date" />
                    <b-form-input
                      class="mt-25"
                      type="text"
                      v-model="s.end_time"
                      placeholder="HH:mm"
                      @blur="onTimeBlur(s, 'end_time')"
                    />
                  </b-col>
                  <b-col md="4">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Venue</label>
                      <a
                        href="#"
                        @click.prevent="openAddVenueModal(idx)"
                        class="text-primary text-decoration-underline"
                        style="font-size: 0.875rem;"
                        >Add Venue</a
                      >
                    </div>
                    <v-select
                      :options="options.venues"
                      label="name"
                      :reduce="(v) => v.id"
                      v-model="s.venue_id"
                    />
                  </b-col>
                </b-row>
                <b-row class="mt-50">
                  <b-col md="6"
                    ><label>Meeting URL</label
                    ><b-form-input v-model="s.meeting_url"
                  /></b-col>
                  <b-col md="3"
                    ><label>Meeting passcode</label
                    ><b-form-input v-model="s.meeting_passcode"
                  /></b-col>
                  <b-col md="3">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Trainer</label>
                      <a
                        href="#"
                        @click.prevent="openAddTrainerModal(idx)"
                        class="text-primary text-decoration-underline"
                        style="font-size: 0.875rem;"
                        >Add Trainer</a
                      >
                    </div>
                    <v-select
                      :options="options.trainers"
                      label="name"
                      :reduce="(t) => t.id"
                      v-model="s.primary_trainer_id"
                    />
                  </b-col>
                </b-row>

                <div class="mt-50">
                  <div class="d-flex justify-content-between align-items-center">
                    <label class="mb-0">Add-ons</label>
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      @click="addAddon(s)"
                    >+ Add add-on</b-button>
                  </div>

                  <div
                    v-if="!s.addons || s.addons.length === 0"
                    class="text-muted small mt-25"
                  >
                    No add-ons
                  </div>

                  <div
                    v-for="(a, aidx) in s.addons"
                    :key="`addon-${idx}-${aidx}`"
                    class="border rounded p-50 mt-50"
                  >
                    <div class="d-flex justify-content-between align-items-center mb-25">
                      <strong class="small">Add-on {{ aidx + 1 }}</strong>
                      <b-button
                        size="sm"
                        variant="outline-danger"
                        @click="removeAddon(s, aidx)"
                      >Remove</b-button>
                    </div>
                    <b-row>
                      <b-col md="4">
                        <label>Code *</label>
                        <b-form-input v-model="a.code" placeholder="lunch" />
                      </b-col>
                      <b-col md="8">
                        <label>Label *</label>
                        <b-form-input v-model="a.label" placeholder="Lunch" />
                      </b-col>
                    </b-row>
                    <b-row class="mt-25">
                      <b-col md="6">
                        <label>Starts time (optional)</label>
                        <b-form-input
                          type="text"
                          v-model="a.starts_time"
                          placeholder="HH:mm"
                          @blur="onAddonTimeBlur(a, 'starts_time')"
                        />
                        <div class="text-muted small mt-25">Uses session start date</div>
                      </b-col>
                      <b-col md="6">
                        <label>Ends time (optional)</label>
                        <b-form-input
                          type="text"
                          v-model="a.ends_time"
                          placeholder="HH:mm"
                          @blur="onAddonTimeBlur(a, 'ends_time')"
                        />
                        <div class="text-muted small mt-25">Uses session end date</div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
              <b-button size="sm" variant="outline-primary" @click="addSession"
                >+ Add part</b-button
              >

              <b-row class="mt-1">
                <b-col md="3"
                  ><b-form-group label="Max participants"
                    ><b-form-input
                      type="number"
                      min="1"
                      v-model.number="form.max_participants"/></b-form-group
                ></b-col>
 
                <b-col md="3" class="d-flex align-items-center"
                  ><b-form-checkbox v-model="form.require_manager_approval"
                    >Require manager approval</b-form-checkbox
                  ></b-col
                >

                <b-col md="3" class="d-flex align-items-center"
                  ><b-form-checkbox v-model="form.require_admin_approval"
                    >Require admin approval</b-form-checkbox
                  ></b-col
                >

                               <b-col md="3" class="d-flex align-items-center"
                  ><b-form-checkbox v-model="form.is_pre_approved"
                    >Mandatory Training</b-form-checkbox
                  ></b-col
                >
              </b-row>

              <b-row class="mt-50">
                <b-col md="12" class="d-flex align-items-center">
                  <b-form-checkbox v-model="form.is_eft">
                    Educational Fee Training (EFT)
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-form-group label="Title *"
                ><b-form-input v-model="form.title_override" required
              /></b-form-group>
              <b-form-group label="Description"
                ><b-form-textarea v-model="form.description_override" rows="2"
              /></b-form-group>
              <b-card class="mt-1" title="Preview">
                <div>
                  <div class="mb-25">
                    <strong>Course:</strong>
                    {{ (selectedCourse && selectedCourse.title) || '-' }}
                  </div>
                  <div class="mb-25">
                    <strong>Aim:</strong>
                    {{ (selectedCourse && selectedCourse.aim) || '-' }}
                  </div>
                  <div class="mb-25">
                    <strong>Learning outcomes:</strong>
                    <ul class="mb-0">
                      <li
                        v-for="(lo, i) in (selectedCourse &&
                          selectedCourse.learning_outcomes) ||
                          []"
                        :key="i"
                      >
                        {{ lo }}
                      </li>
                    </ul>
                  </div>
                </div>
              </b-card>
            </app-collapse-item>

            <!-- Application Methods -->
            <app-collapse-item title="Application Methods">
              <b-row>
                <b-col md="6"
                  ><b-form-group label="Application method"
                    ><v-select
                      :options="options.enums.application_methods"
                      v-model="form.application_method"
                      :reduce="(v) => v"/></b-form-group
                ></b-col>
                <b-col md="6"
                  ><b-form-group label="Application deadline"
                    ><b-form-input
                      type="date"
                      v-model="form.application_deadline"/></b-form-group
                ></b-col>
              </b-row>
            </app-collapse-item>

            <!-- Materials -->
            <app-collapse-item title="Materials">
              <b-alert variant="light" show>
                Materials can be added on the event after duplication.
              </b-alert>
            </app-collapse-item>

            <!-- Target Audience -->
            <app-collapse-item title="Target Audience">
              <b-row>
                <b-col md="4">
                  <b-form-group>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Companies</label>
                      <div class="text-right">
                        <a
                          v-if="form.company_ids.length === 0"
                          href="#"
                          @click.prevent="selectAllCompanies"
                          class="text-primary text-decoration-underline"
                          style="font-size: 0.875rem;"
                        >
                          Select All
                        </a>
                        <a
                          v-else
                          href="#"
                          @click.prevent="clearAllCompanies"
                          class="text-danger text-decoration-underline"
                          style="font-size: 0.875rem;"
                        >
                          Clear All
                        </a>
                      </div>
                    </div>
                    <v-select
                      multiple
                      :options="options.companies"
                      label="title"
                      :reduce="(c) => c.id"
                      v-model="form.company_ids"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Sites</label>
                      <div class="text-right">
                        <a
                          v-if="form.site_ids.length === 0"
                          href="#"
                          @click.prevent="selectAllSites"
                          class="text-primary text-decoration-underline"
                          style="font-size: 0.875rem;"
                        >
                          Select All
                        </a>
                        <a
                          v-else
                          href="#"
                          @click.prevent="clearAllSites"
                          class="text-danger text-decoration-underline"
                          style="font-size: 0.875rem;"
                        >
                          Clear All
                        </a>
                      </div>
                    </div>
                    <v-select
                      multiple
                      :options="options.sites || []"
                      label="title"
                      :reduce="(s) => s.id"
                      v-model="form.site_ids"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>Users</label>
                      <div class="text-right">
                        <a
                          v-if="form.user_ids.length === 0"
                          href="#"
                          @click.prevent="selectAllUsers"
                          class="text-primary text-decoration-underline"
                          style="font-size: 0.875rem;"
                        >
                          Select All
                        </a>
                        <a
                          v-else
                          href="#"
                          @click.prevent="clearAllUsers"
                          class="text-danger text-decoration-underline"
                          style="font-size: 0.875rem;"
                        >
                          Clear All
                        </a>
                      </div>
                    </div>
                    <v-select
                      multiple
                      :options="options.users"
                      label="title"
                      :reduce="(u) => u.id"
                      v-model="form.user_ids"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <label>Roles</label>
                      <div class="text-right">
                        <a
                          v-if="form.role_ids.length === 0"
                          href="#"
                          @click.prevent="selectAllRoles"
                          class="text-primary text-decoration-underline"
                          style="font-size: 0.875rem;"
                        >
                          Select All
                        </a>
                        <a
                          v-else
                          href="#"
                          @click.prevent="clearAllRoles"
                          class="text-danger text-decoration-underline"
                          style="font-size: 0.875rem;"
                        >
                          Clear All
                        </a>
                      </div>
                    </div>
                    <v-select
                      multiple
                      :options="options.roles"
                      label="name"
                      :reduce="(r) => r.id"
                      v-model="form.role_ids"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <div class="mt-1">
                <div class="border rounded p-75">
                  <div class="d-flex align-items-center justify-content-between">
                    <small class="text-muted">Audience preview</small>
                    <small v-if="audiencePreview.loading" class="text-muted">Loading...</small>
                    <small v-else class="text-muted">{{ audiencePreview.count }} users</small>
                  </div>
                  <small v-if="!audiencePreviewHasFilters" class="text-danger d-block mt-25">
                    if no filters are selected, all companies are in the target audience
                  </small>
                  <div v-if="audiencePreview.error" class="text-danger small mt-25">
                    Failed to load audience preview
                  </div>
                  <ul
                    v-else
                    class="small mb-0 pl-1 mt-50"
                    style="max-height: 150px; overflow: auto;"
                  >
                    <li
                      v-for="u in audiencePreviewVisibleUsers"
                      :key="u.id"
                      :title="u.full_name || (u.name ? (u.name + ' ' + (u.surname || '')) : '')"
                    >
                      {{ u.email }}
                    </li>
                  </ul>
                  <small
                    v-if="!audiencePreview.loading && audiencePreview.count > audiencePreviewVisibleUsers.length"
                    class="text-muted d-block mt-25"
                  >
                    Showing first {{ audiencePreviewVisibleUsers.length }} of {{ audiencePreview.count }}
                  </small>
                </div>
              </div>

              <b-card class="mt-1" title="Event Coordinators">
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="mb-0">Select coordinators</h6>
                  <div class="text-right">
                    <a
                      v-if="admin_user_ids.length === 0"
                      href="#"
                      @click.prevent="selectAllAdmins"
                      class="text-primary text-decoration-underline"
                      style="font-size: 0.875rem;"
                    >
                      Select All
                    </a>
                    <a
                      v-else
                      href="#"
                      @click.prevent="clearAllAdmins"
                      class="text-danger text-decoration-underline"
                      style="font-size: 0.875rem;"
                    >
                      Clear All
                    </a>
                  </div>
                </div>
                <v-select
                  multiple
                  :options="options.users"
                  label="title"
                  :reduce="(u) => u.id"
                  v-model="admin_user_ids"
                />
              </b-card>
            </app-collapse-item>

            <!-- Event Reminders -->
            <app-collapse-item title="Event Reminders">
              <p class="text-muted small">
                Set up automatic reminders to be sent to participants before the
                event starts.
              </p>
              <div
                v-for="(reminder, idx) in reminders"
                :key="`reminder-${idx}`"
                class="border rounded p-1 mb-1"
              >
                <div
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <h6 class="mb-0">Reminder {{ idx + 1 }}</h6>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="removeReminder(idx)"
                    >Remove</b-button
                  >
                </div>
                <b-row>
                  <b-col md="4">
                    <label>Days Before Event *</label>
                    <b-form-input
                      type="number"
                      v-model.number="reminder.days_before"
                      min="1"
                      max="30"
                      placeholder="e.g. 3"
                      required
                    />
                  </b-col>
                  <b-col md="8">
                    <label>Custom Message (Optional)</label>
                    <b-form-input
                      v-model="reminder.message"
                      placeholder="Custom reminder message..."
                    />
                  </b-col>
                </b-row>
              </div>
              <b-button size="sm" variant="outline-primary" @click="addReminder"
                >+ Add Reminder</b-button
              >
            </app-collapse-item>
          </app-collapse>

          <div class="d-flex mt-2">
            <b-button
              type="submit"
              variant="primary"
              class="mr-1"
              :disabled="loading"
              >Save</b-button
            >
            <b-button
              variant="outline-secondary"
              @click="$router.push({ name: 'events' })"
              >Cancel</b-button
            >
          </div>
        </b-form>
      </b-overlay>
    </b-card>

    <!-- Add Venue Modal -->
    <b-modal
      v-model="showAddVenueModal"
      title="Add New Venue"
      @ok="handleAddVenue"
      @cancel="resetVenueForm"
      ok-title="Add"
      cancel-title="Cancel"
    >
      <b-form-group label="Name *" label-for="venue-name">
        <b-form-input
          id="venue-name"
          v-model="newVenue.name"
          placeholder="Enter venue name"
          required
        />
      </b-form-group>
    </b-modal>

    <!-- Add Trainer Modal -->
    <b-modal
      v-model="showAddTrainerModal"
      title="Add New Trainer"
      @ok="handleAddTrainer"
      @cancel="resetTrainerForm"
      ok-title="Add"
      cancel-title="Cancel"
    >
      <b-form-group label="Name *" label-for="trainer-name">
        <b-form-input
          id="trainer-name"
          v-model="newTrainer.name"
          placeholder="Enter trainer name"
          required
        />
      </b-form-group>
      <b-form-group label="Email *" label-for="trainer-email">
        <b-form-input
          id="trainer-email"
          v-model="newTrainer.email"
          type="email"
          placeholder="Enter trainer email"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
          required
        />
      </b-form-group>
      <b-form-group label="Phone" label-for="trainer-phone">
        <b-form-input
          id="trainer-phone"
          v-model="newTrainer.phone"
          placeholder="Enter trainer phone"
        />
      </b-form-group>
      <b-form-group label="CV (PDF)" label-for="trainer-cv">
        <b-form-file
          id="trainer-cv"
          v-model="newTrainerCV"
          accept=".pdf"
          placeholder="Choose a PDF file or drop it here..."
          drop-placeholder="Drop PDF file here..."
        />
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BButton,
  BModal,
  BFormFile,
  BAlert,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import eventsStoreModule from "./eventsStoreModule";
import settingsStoreModule from "@/views/settings/settingsStoreModule";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BModal,
    BFormFile,
    BAlert,
    vSelect,
    ToastificationContent,
    AppCollapse,
    AppCollapseItem,
  },
  data() {
    return {
      loading: false,
      loaded: false,
      options: {
        courses: [],
        users: [],
        trainers: [],
        venues: [],
        companies: [],
        sites: [],
        roles: [],
        enums: { event_statuses: [], application_methods: [] },
      },
      form: {
        id: null,
        course_id: null,
        year: new Date().getFullYear(),
        title_override: "",
        description_override: "",
        status: "draft",
        max_participants: null,
        application_method: null,
        application_deadline: null,
        require_manager_approval: false,
        require_admin_approval: false,
        is_pre_approved: false,
        is_eft: false,
        time_zone: "Europe/Dublin",
        notes_admin: "",
        company_ids: [],
        site_ids: [],
        user_ids: [],
        role_ids: [],
      },
      sessions: [],
      reminders: [],
      admin_user_ids: [],
      selectedCourse: null,
      // Modal states
      showAddVenueModal: false,
      showAddTrainerModal: false,
      currentSessionIndex: null, // Track which session is being edited
      // New item forms
      newVenue: {
        name: "",
      },
      newTrainer: {
        name: "",
        email: "",
        phone: "",
      },
      newTrainerCV: null,

      audiencePreview: { loading: false, count: 0, users: [], error: null },
      audiencePreviewRequestId: 0,
      audiencePreviewTimer: null,
    };
  },
  computed: {
    audiencePreviewHasFilters() {
      const c = Array.isArray(this.form.company_ids) ? this.form.company_ids.length : 0;
      const s = Array.isArray(this.form.site_ids) ? this.form.site_ids.length : 0;
      const r = Array.isArray(this.form.role_ids) ? this.form.role_ids.length : 0;
      const u = Array.isArray(this.form.user_ids) ? this.form.user_ids.length : 0;
      return c + s + r + u > 0;
    },
    audiencePreviewVisibleUsers() {
      const users = (this.audiencePreview && Array.isArray(this.audiencePreview.users))
        ? this.audiencePreview.users
        : [];
      return users.slice(0, 20);
    },
  },
  setup() {
    const MODULE = "events";
    if (!store.hasModule(MODULE))
      store.registerModule(MODULE, eventsStoreModule);

    const SETTINGS_MODULE = "settings";
    if (!store.hasModule(SETTINGS_MODULE))
      store.registerModule(SETTINGS_MODULE, settingsStoreModule);

    onUnmounted(() => {
      if (store.hasModule(MODULE)) store.unregisterModule(MODULE);
      if (store.hasModule(SETTINGS_MODULE))
        store.unregisterModule(SETTINGS_MODULE);
    });
  },
  async created() {
    await this.loadOptions();
    this.loadEvent();
  },
  beforeDestroy() {
    if (this.audiencePreviewTimer) clearTimeout(this.audiencePreviewTimer);
  },
  watch: {
    'form.course_id'(newVal) {
      if (!newVal) return;
      store.dispatch('events/getCourseById', { id: newVal }).then(res => {
        const course = res.data;
        this.selectedCourse = course;
        if (!this.form.title_override || this.form.title_override.trim() === '') {
          this.form.title_override = (course.title || '') + ' (Duplicate)';
        }
        if (!this.form.description_override || this.form.description_override.trim() === '') {
          this.form.description_override = course.summary || '';
        }
      }).catch(() => {});
    },
    "form.company_ids": {
      handler() {
        this.queueAudiencePreview();
      },
      deep: true,
    },
    "form.site_ids": {
      handler() {
        this.queueAudiencePreview();
      },
      deep: true,
    },
    "form.user_ids": {
      handler() {
        this.queueAudiencePreview();
      },
      deep: true,
    },
    "form.role_ids": {
      handler() {
        this.queueAudiencePreview();
      },
      deep: true,
    },
  },
  methods: {
    queueAudiencePreview() {
      if (!this.loaded) return;
      if (this.audiencePreviewTimer) clearTimeout(this.audiencePreviewTimer);
      this.audiencePreviewTimer = setTimeout(() => {
        this.previewAudience();
      }, 350);
    },
    previewAudience() {
      if (!this.loaded) return;
      const payload = {
        companyIds: Array.isArray(this.form.company_ids) ? this.form.company_ids.filter(Boolean) : [],
        siteIds: Array.isArray(this.form.site_ids) ? this.form.site_ids.filter(Boolean) : [],
        roleIds: Array.isArray(this.form.role_ids) ? this.form.role_ids.filter(Boolean) : [],
        userIds: Array.isArray(this.form.user_ids) ? this.form.user_ids.filter(Boolean) : [],
      };

      const requestId = ++this.audiencePreviewRequestId;
      this.audiencePreview.loading = true;
      this.audiencePreview.error = null;
      store
        .dispatch("events/previewAudience", payload)
        .then((res) => {
          if (requestId !== this.audiencePreviewRequestId) return;
          const data = (res && res.data) || {};
          this.audiencePreview = {
            loading: false,
            count: data.count || 0,
            users: Array.isArray(data.users) ? data.users : [],
            error: null,
          };
        })
        .catch(() => {
          if (requestId !== this.audiencePreviewRequestId) return;
          this.audiencePreview.loading = false;
          this.audiencePreview.error = true;
          this.audiencePreview.count = 0;
          this.audiencePreview.users = [];
        });
    },
    dateFormat(val) {
      if (!val) return "-";
      const date = new Date(val);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const time = date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
      return `${day}-${month}-${year} ${time}`;
    },
    async loadOptions() {
      try {
        const res = await store.dispatch("events/fetchEventOptions");
        this.options = res.data;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Failed to load options",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    getPartTitle(idx) {
      const title =
        this.form.title_override ||
        (this.selectedCourse ? this.selectedCourse.title : "");
      if (this.sessions.length <= 1) {
        return title || 'Event timing';
      }
      return title ? `${title} - Part ${idx + 1}` : `Part ${idx + 1}`;
    },
    // Select All / Clear All methods for Companies
    selectAllCompanies() {
      this.form.company_ids = this.options.companies.map((c) => c.id);
    },
    clearAllCompanies() {
      this.form.company_ids = [];
    },
    // Select All / Clear All methods for Users
    selectAllUsers() {
      this.form.user_ids = this.options.users.map((u) => u.id);
    },
    clearAllUsers() {
      this.form.user_ids = [];
    },
    // Select All / Clear All methods for Sites
    selectAllSites() {
      const sites = this.options.sites || [];
      this.form.site_ids = sites.map((s) => s.id);
    },
    clearAllSites() {
      this.form.site_ids = [];
    },
    // Select All / Clear All methods for Roles
    selectAllRoles() {
      this.form.role_ids = this.options.roles.map((r) => r.id);
    },
    clearAllRoles() {
      this.form.role_ids = [];
    },
    // Select All / Clear All methods for Admins
    selectAllAdmins() {
      this.admin_user_ids = this.options.users.map((u) => u.id);
    },
    clearAllAdmins() {
      this.admin_user_ids = [];
    },
    async loadEvent() {
      try {
        const id = this.$route.params.id;
        const res = await store.dispatch("events/getEventById", { id });
        const ev = res.data;

        // Copy event data but clear ID for duplication
        this.form = { ...this.form, ...ev };
        this.form.id = null; // Clear ID so it creates new event

        // Add "(Duplicate)" to title
        if (this.form.title_override) {
          this.form.title_override += " (Duplicate)";
        } else if (ev.course && ev.course.title) {
          this.form.title_override = ev.course.title + " (Duplicate)";
        }

        this.selectedCourse = ev.course;

        // If description empty, take from course summary
        if ((!this.form.description_override || this.form.description_override.trim() === '') && this.selectedCourse) {
          this.form.description_override = this.selectedCourse.summary || '';
        }

        // Load existing audience
        this.form.company_ids = ev.companies?.map((c) => c.id) || [];
        this.form.site_ids = ev.sites?.map((s) => s.id) || [];
        this.form.user_ids = (ev.audience_users || [])?.map((u) => u.id) || [];
        this.form.role_ids = ev.roles?.map((r) => r.id) || [];

        // Load existing admins
        this.admin_user_ids = (ev.admins || []).map((u) => u.id);

        // Load sessions but clear IDs (split datetime into date/time fields)
        const sessionsRes = await store.dispatch("events/listSessions", { id });
        this.sessions = sessionsRes.data.map((s) => ({
          id: null, // Clear ID for duplication
          sequence_no: s.sequence_no,
          start_date: s.start_at ? s.start_at.substring(0, 10) : "",
          start_time: s.start_at ? s.start_at.substring(11, 16) : "",
          end_date: s.end_at ? s.end_at.substring(0, 10) : "",
          end_time: s.end_at ? s.end_at.substring(11, 16) : "",
          venue_id: (s.venue && s.venue.id) || s.venue_id,
          meeting_url: s.meeting_url,
          meeting_passcode: s.meeting_passcode,
          primary_trainer_id:
            s.primary_trainer_id || (s.primaryTrainer && s.primaryTrainer.id),
          addons: this._deserializeAddons(
            s.addons || s.session_addons || s.add_ons || []
          ),
        }));
        if (this.sessions.length === 0) {
          this.addSession();
        }

        // Load existing reminders
        this.reminders = ev.event_reminders || [];

        // Format application_deadline for date input (YYYY-MM-DD)
        if (ev.application_deadline) {
          const date = new Date(ev.application_deadline);
          this.form.application_deadline = date.toISOString().split("T")[0];
        }

        this.loaded = true;

        this.queueAudiencePreview();
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Failed to load event",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    addSession() {
      this.sessions.push({
        sequence_no: this.sessions.length + 1,
        start_date: "",
        start_time: "",
        end_date: "",
        end_time: "",
        venue_id: null,
        meeting_url: "",
        meeting_passcode: "",
        primary_trainer_id: null,
        addons: [],
      });
    },
    removeSession(idx) {
      this.sessions.splice(idx, 1);
      this.sessions.forEach((s, idx) => {
        s.sequence_no = idx + 1;
      });
    },
    async saveSession(s, eventId) {
      // Skip sessions with empty required fields (date/time pairs)
      if (!s.start_date || !s.start_time || !s.end_date || !s.end_time) {
        console.log("Skipping session with empty date/time:", s);
        return;
      }

      // Validation is performed in onSubmit; here we just format and send
      const sessionData = {
        sequence_no: s.sequence_no,
        venue_id: s.venue_id,
        meeting_url: s.meeting_url,
        meeting_passcode: s.meeting_passcode,
        primary_trainer_id: s.primary_trainer_id,
        start_at: this._combineDateTimeForBackend(s.start_date, s.start_time),
        end_at: this._combineDateTimeForBackend(s.end_date, s.end_time),
        addons: this._buildAddonsPayload(s),
      };

      await store.dispatch("events/addSession", {
        id: eventId,
        data: sessionData,
      });
    },
    async onSubmit() {
      try {
        // Validate required fields
        if (!this.form.course_id) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Validation Error",
              text: "Please select a course",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return;
        }

        if (!this.form.year) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Validation Error",
              text: "Please enter a year",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return;
        }
        // Validate all sessions before creating event
        for (const s of this.sessions) {
          if (!s.start_date || !s.start_time || !s.end_date || !s.end_time) {
            continue;
          }
          const st = this._normalizeTime(s.start_time);
          const et = this._normalizeTime(s.end_time);
          const start = this._toDateObj(`${s.start_date}T${st}:00`);
          const end = this._toDateObj(`${s.end_date}T${et}:00`);
          if (!st || !et || !start || !end || end <= start) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Session Date Error',
                text: `Part ${s.sequence_no}: End time must be after start time`,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            });
            return;
          }

          if (!this._validateSessionAddons(s)) {
            return;
          }
        }

        if (!this.form.time_zone) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Validation Error",
              text: "Please enter a time zone",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return;
        }

        if (
          !this.form.title_override ||
          this.form.title_override.trim() === ""
        ) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Validation Error",
              text: "Please enter a title",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return;
        }

        this.loading = true;

        // Create new event (duplicate)
        const res = await store.dispatch("events/saveEvent", {
          ...this.form,
          reminders: this.reminders,
        });

        const eventId = res.data.id;

        // Add all sessions to the new event
        for (const s of this.sessions) {
          try {
            await this.saveSession(s, eventId);
          } catch (error) {
            console.error("Error saving session:", error);
          }
        }

        // Set event admins
        if (this.admin_user_ids.length > 0) {
          await store.dispatch("events/setEventAdmins", {
            id: eventId,
            admin_user_ids: this.admin_user_ids,
          });
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Event duplicated successfully",
            icon: "ThumbsUpIcon",
            variant: "success",
          },
        });
        this.$router.push({ name: "events" });
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Failed to duplicate event",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.loading = false;
      }
    },
    // Modal methods
    openAddVenueModal(sessionIndex) {
      this.currentSessionIndex = sessionIndex;
      this.showAddVenueModal = true;
    },
    openAddTrainerModal(sessionIndex) {
      this.currentSessionIndex = sessionIndex;
      this.showAddTrainerModal = true;
    },
    async handleAddVenue(bvModalEvent) {
      bvModalEvent.preventDefault();
      if (!this.newVenue.name.trim()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please fill venue name",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      try {
        const response = await store.dispatch(
          "settings/createVenue",
          this.newVenue
        );
        const newVenue = response.data.data;
        this.options.venues.push(newVenue);

        // Auto-select the newly added venue in the current session
        if (
          this.currentSessionIndex !== null &&
          this.sessions[this.currentSessionIndex]
        ) {
          this.sessions[this.currentSessionIndex].venue_id = newVenue.id;
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Venue added successfully",
            icon: "ThumbsUpIcon",
            variant: "success",
          },
        });
        this.resetVenueForm();
        this.showAddVenueModal = false;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error adding venue",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async handleAddTrainer(bvModalEvent) {
      bvModalEvent.preventDefault();
      if (!this.newTrainer.name.trim() || !this.newTrainer.email.trim()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please fill all required trainer fields",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      // Email format validation
      const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
      if (!emailRegex.test(this.newTrainer.email.trim())) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please enter a valid email address",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      try {
        // Create FormData for file upload
        const formData = new FormData();
        formData.append("name", this.newTrainer.name.trim());
        formData.append("email", this.newTrainer.email.trim());
        if (this.newTrainer.phone.trim()) {
          formData.append("phone", this.newTrainer.phone.trim());
        }
        if (this.newTrainerCV) {
          formData.append("cv_pdf", this.newTrainerCV);
        }

        // Add to options via API call
        const response = await store.dispatch(
          "settings/createTrainerWithFile",
          formData
        );
        const newTrainer = response.data.data;
        this.options.trainers.push(newTrainer);

        // Auto-select the newly added trainer in the current session
        if (
          this.currentSessionIndex !== null &&
          this.sessions[this.currentSessionIndex]
        ) {
          this.sessions[this.currentSessionIndex].primary_trainer_id =
            newTrainer.id;
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Trainer added successfully",
            icon: "ThumbsUpIcon",
            variant: "success",
          },
        });
        this.resetTrainerForm();
        this.showAddTrainerModal = false;
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error adding trainer",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    resetVenueForm() {
      this.newVenue = {
        name: "",
      };
    },
    resetTrainerForm() {
      this.newTrainer = {
        name: "",
        email: "",
        phone: "",
      };
      this.newTrainerCV = null;
    },
    addReminder() {
      this.reminders.push({
        days_before: 3,
        message: "",
        type: "event_reminder",
        is_active: true,
      });
    },
    removeReminder(index) {
      this.reminders.splice(index, 1);
    },
    // Helpers for datetime parsing/formatting (aligned with Add/Edit views)
    _toDateObj(val) {
      if (!val || typeof val !== 'string') return null;
      const d = new Date(val);
      return isNaN(d.getTime()) ? null : d;
    },
    _normalizeTime(time) {
      if (!time || typeof time !== 'string') return null;
      const t = time.trim();
      if (/^\d{1,2}:\d{2}$/.test(t)) return this._padTime(t);
      if (/^\d{3,4}$/.test(t)) {
        const part = t.length === 3 ? `0${t}` : t;
        const hh = part.slice(0, 2);
        const mm = part.slice(2);
        return this._padTime(`${hh}:${mm}`);
      }
      return null;
    },
    _padTime(tt) {
      const [h, m] = tt.split(':');
      const hh = String(parseInt(h, 10)).padStart(2, '0');
      const mm = String(parseInt(m, 10)).padStart(2, '0');
      if (+hh < 0 || +hh > 23 || +mm < 0 || +mm > 59) return null;
      return `${hh}:${mm}`;
    },
    _combineDateTimeForBackend(date, time) {
      const t = this._normalizeTime(time);
      if (!date || !t) return null;
      return `${date} ${t}:00`;
    },
    onTimeBlur(session, key) {
      const norm = this._normalizeTime(session[key]);
      if (norm) session[key] = norm;
    },

    addAddon(session) {
      if (!session.addons) this.$set(session, 'addons', []);
      session.addons.push({
        id: null,
        code: "",
        label: "",
        starts_time: "",
        ends_time: "",
        is_required: false,
        sort_order: null,
      });
    },
    removeAddon(session, addonIndex) {
      if (!session.addons) return;
      session.addons.splice(addonIndex, 1);
    },
    onAddonTimeBlur(addon, key) {
      const norm = this._normalizeTime(addon[key]);
      if (norm) addon[key] = norm;
    },
    _splitDateTime(val) {
      if (!val || typeof val !== 'string') return { date: '', time: '' };
      const trimmed = val.trim();
      const iso = trimmed.includes('T') ? trimmed : trimmed.replace(' ', 'T');
      return {
        date: iso.length >= 10 ? iso.substring(0, 10) : '',
        time: iso.length >= 16 ? iso.substring(11, 16) : '',
      };
    },
    _deserializeAddons(raw) {
      const arr = Array.isArray(raw) ? raw : [];
      return arr.map((a) => {
        const starts = this._splitDateTime(a.starts_at);
        const ends = this._splitDateTime(a.ends_at);
        const sortOrder =
          a.sort_order !== undefined && a.sort_order !== null
            ? a.sort_order
            : (a.sort !== undefined && a.sort !== null ? a.sort : null);
        return {
          id: a.id || null,
          code: a.code || '',
          label: a.label || '',
          starts_time: starts.time,
          ends_time: ends.time,
          is_required: !!(a.is_required || a.required),
          sort_order: sortOrder,
        };
      });
    },
    _buildAddonsPayload(session) {
      const list = Array.isArray(session.addons) ? session.addons : [];
      const out = [];
      for (let i = 0; i < list.length; i++) {
        const a = list[i] || {};
        const code = String(a.code || '').trim().toLowerCase();
        const label = String(a.label || '').trim();
        const hasAny =
          code ||
          label ||
          a.starts_time ||
          a.ends_time;
        if (!hasAny) continue;

        const starts_at =
          session.start_date && a.starts_time
            ? this._combineDateTimeForBackend(session.start_date, a.starts_time)
            : null;
        const ends_at =
          session.end_date && a.ends_time
            ? this._combineDateTimeForBackend(session.end_date, a.ends_time)
            : null;

        const payload = {
          code,
          label,
          starts_at,
          ends_at,
        };

        if (a.id) payload.id = a.id;
        if (typeof a.is_required === 'boolean') payload.is_required = a.is_required;

        const sortOrder =
          a.sort_order !== undefined && a.sort_order !== null
            ? a.sort_order
            : (a.sort !== undefined && a.sort !== null ? a.sort : null);
        if (sortOrder !== null) payload.sort_order = sortOrder;
        else payload.sort_order = i + 1;

        out.push(payload);
      }
      return out;
    },
    _validateSessionAddons(session) {
      const list = Array.isArray(session.addons) ? session.addons : [];
      for (let i = 0; i < list.length; i++) {
        const a = list[i] || {};
        const code = String(a.code || '').trim();
        const label = String(a.label || '').trim();
        const hasAny =
          code ||
          label ||
          a.starts_time ||
          a.ends_time;
        if (!hasAny) continue;

        if (!code || !label) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Add-on Validation Error",
              text: `Part ${session.sequence_no}, Add-on ${i + 1}: Code and Label are required`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return false;
        }
        if (code.length > 50) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Add-on Validation Error",
              text: `Part ${session.sequence_no}, Add-on ${i + 1}: Code must be 50 characters or less`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return false;
        }
        if (label.length > 255) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Add-on Validation Error",
              text: `Part ${session.sequence_no}, Add-on ${i + 1}: Label must be 255 characters or less`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return false;
        }

        if (a.starts_time && !session.start_date) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Add-on Date Error",
              text: `Part ${session.sequence_no}, Add-on ${i + 1}: Session start date is required when add-on start time is set`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return false;
        }
        if (a.ends_time && !session.end_date) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Add-on Date Error",
              text: `Part ${session.sequence_no}, Add-on ${i + 1}: Session end date is required when add-on end time is set`,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return false;
        }

        if (session.start_date && a.starts_time && session.end_date && a.ends_time) {
          const st = this._normalizeTime(a.starts_time);
          const et = this._normalizeTime(a.ends_time);
          const start = this._toDateObj(`${session.start_date}T${st}:00`);
          const end = this._toDateObj(`${session.end_date}T${et}:00`);
          if (!st || !et || !start || !end || end <= start) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Add-on Date Error",
                text: `Part ${session.sequence_no}, Add-on ${i + 1}: Ends must be after starts`,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
            return false;
          }
        }
      }
      return true;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
